import React from 'react';
import { Box, Typography, Paper, Radio, RadioGroup, FormControlLabel } from '@mui/material';

export default function QuestionCard({ question, selectedIndex, onSelect, showResult, result }) {
  const isCorrect = result?.correct;
  const correctIdx = result?.correct_answer_index;

  return (
    <Box sx={{ animation: 'fadeUp 0.4s ease-out', '@keyframes fadeUp': { from: { opacity: 0, transform: 'translateY(16px)' }, to: { opacity: 1, transform: 'translateY(0)' } } }}>
      <Typography variant="overline" sx={{ color: 'primary.main', fontWeight: 600, letterSpacing: '0.1em', mb: 1, display: 'block' }}>
        {question.topic}
      </Typography>
      <Typography variant="h6" sx={{ mb: 3, lineHeight: 1.5, fontWeight: 400, fontSize: '1.05rem' }}>
        {question.question_text}
      </Typography>

      <RadioGroup value={selectedIndex !== null && selectedIndex !== undefined ? String(selectedIndex) : ''} onChange={(e) => !showResult && onSelect(parseInt(e.target.value))}>
        {question.options.map((opt, i) => {
          let borderColor = 'rgba(78, 219, 161, 0.08)';
          let bg = 'transparent';
          if (showResult) {
            if (i === correctIdx) { borderColor = '#4edba1'; bg = 'rgba(78, 219, 161, 0.08)'; }
            else if (i === selectedIndex && !isCorrect) { borderColor = '#f0656f'; bg = 'rgba(240, 101, 111, 0.08)'; }
          } else if (i === selectedIndex) {
            borderColor = '#4edba1'; bg = 'rgba(78, 219, 161, 0.06)';
          }

          return (
            <Paper key={i} sx={{ mb: 1.5, px: 2, py: 0.5, border: `1.5px solid ${borderColor}`, background: bg, transition: 'all 0.2s ease', cursor: showResult ? 'default' : 'pointer', '&:hover': showResult ? {} : { borderColor: '#4edba1', background: 'rgba(78, 219, 161, 0.04)' } }}
              onClick={() => !showResult && onSelect(i)}>
              <FormControlLabel
                value={String(i)}
                control={<Radio size="small" disabled={showResult} sx={{ color: '#8b99b0', '&.Mui-checked': { color: '#4edba1' } }} />}
                label={<Typography sx={{ fontSize: '0.92rem', py: 0.5 }}>{opt}</Typography>}
                sx={{ width: '100%', m: 0 }}
              />
            </Paper>
          );
        })}
      </RadioGroup>

      {showResult && result?.rationale && (
        <Paper sx={{ mt: 2, p: 2.5, background: 'rgba(78, 219, 161, 0.04)', borderColor: 'rgba(78, 219, 161, 0.15)', animation: 'fadeUp 0.3s ease-out' }}>
          <Typography variant="overline" sx={{ color: isCorrect ? 'primary.main' : 'error.main', fontWeight: 700, letterSpacing: '0.08em' }}>
            {isCorrect ? '✓ Correct' : '✗ Incorrect'}
          </Typography>
          <Typography sx={{ mt: 1, fontSize: '0.88rem', color: 'text.secondary', lineHeight: 1.6 }}>
            {result.rationale}
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
